import {action, observable, runInAction} from "mobx";
import {customEvent, lessonParamsForAnalytics} from "../../../utils/analyticsUtil";
import {actions, category, events, ProjectType} from "../../../constants/enums";
import projectStore from '../project/store';
import groupStore from "../groups/store";
import {getId, getOwnerDetails} from "../../../utils/userUtility";
import appStore from "../../app/store";
import {getCurrentPageAction} from "../../../utils/navigationUtility";


class AssignGroupStore {
    @observable isAssignDialogOpen = false;
    @observable lesson;
    @observable selectedGroups = [];
    @observable hasChanges = false;

    @action onToggleAssignDialog = (lesson) => {
        this.isAssignDialogOpen = !this.isAssignDialogOpen;
        this.selectedGroup = null;
        this.hasChanges = false;
        this.lesson = null;
        if (this.isAssignDialogOpen) {
            this.selectedGroups = groupStore.groups
                .map(s => ({...s, selected: false}));
            this.lesson = lesson;
            // let selectedGroup = this.selectedGroups.filter(g=>g.selected);
            // this.selectedGroup = selectedGroup && selectedGroup.length > 0 ? selectedGroup[0] : null;
        }
    };

    @action toggleSelected = (group) => {
        this.selectedGroups.map(g => {
            if (g.id === group.id) {
                g.selected = !g.selected;
                if (group.selected) {
                    this.selectedGroup = group;
                }
            } else {
                g.selected = false;
            }
        })
        this.hasChanges = true;
    }

    @action onAssignSave = async (match) => {
        this.submitted = true;
        const selectedGroup = this.selectedGroup;
        let lesson = this.lesson;
        if (lesson.type === ProjectType.Global) {
            lesson = await projectStore.addLessonToLessonPlansNew(lesson, null, null, false);
        } else {
            lesson = await projectStore.fetchProject(this.lesson.id, true, true) || this.lesson;
        }
        this.onToggleAssignDialog();
        if (!selectedGroup) {
            return;
        }
        try {
            const newLessonParams = {
                groupId: selectedGroup.id,
                groupName: selectedGroup.name,
                userId: getId(),
                ...getOwnerDetails(),
                id: undefined
            };
            await projectStore.saveProject(lesson.name, Object.assign({}, lesson, newLessonParams), false, true, false, false);
            appStore.createAlertFromMessageId('success', 'manage.assign.group.success', {groupName: selectedGroup.name}, 5000);
            const lessonProps = getCurrentPageAction(match) === actions.FromMusicoLibrary ? lessonParamsForAnalytics(lesson) : "";
            customEvent(events.CustomEvent, {
                category: category.AssignGroupLesson,
                actions: getCurrentPageAction(match),
                ...lessonProps
            });
        } catch (err) {
            appStore.createAlertFromMessageId('error', 'manage.assign.error');
            console.log(err);
        } finally {
            runInAction(() => {
                this.submitted = false;
            });
        }
    }

}


const assignGroupStore = new AssignGroupStore();
export default assignGroupStore;
